<div class="nexsys-monitor-header">
	<div class="go-back" *ngIf="showBackLink">
		<a href="javascript:void(0)" (click)="goBack()">
			<i class="fa fa-arrow-left"></i>
		</a>
	</div>

	<div *ngIf="showBackLink" (click)="goBack()" class="go-back-link nexsys-monitor-header__title">
		 Monitor - {{ headerSubtitle }}
	</div>

	<div *ngIf="!showBackLink" class="nexsys-monitor-header__title">
		 Monitor - {{ headerSubtitle }}
	</div>

	<div class="nexsys-monitor-header__search">
		<cv-dropdown
			[placeholder]="'Select an Origin'"
			[selectedValue]="originSelected"
			[options]="originList"
			[clearSelection]="clearSourceSelected"
			(valuesChange)="onOriginSelected($event)"
			*ngIf="originList.length"
		>
		</cv-dropdown>
		<cv-input
			[type]="'text'"
			[placeholder]="placeholderInput"
			[value]="nexsysOrderId"
			[maxlength]="100"
			(controlChange)="nexsysOrderId = $event.value"
			*ngIf="originList.length && origin !== 'Nexsys Legacy'"
		>
		</cv-input>
		<cv-input
			[type]="'text'"
			[placeholder]="placeholderInputTransactionId"
			[value]="xpanseTransactionId"
			[maxlength]="100"
			(controlChange)="xpanseTransactionId = $event.value"
			class="xpanseTransactionId"
			*ngIf="origin === 'Xpanse'"
		>
		</cv-input>

		<button class="btn btn-sm cv-btn-light cv-btn-white" (click)="onSearchOrder()"  *ngIf="canSearch && originList.length && origin !== 'Nexsys Legacy'">
			<i class="fas fa-search"></i> {{ btnText }}
		</button>
		<button class="btn btn-sm cv-btn-light cv-btn-white" (click)="reloadList()">
			<i class="fas fa-sync-alt"></i> Update List
		</button>
	</div>
</div>
